		
<div class="filter-btn">
	<div>									
		<i class="fa" (click)="filterClicked($event)"
		[ngClass]="filterIsToggled ? 'fa-times fa-lg' : 'fa-filter'" #filterBtn></i>
	</div>
	<i id="resetButton" *ngIf="filterIsToggled" class="fas fa-sync" onclick="form.reset();" (click)="onResetClick($event)"></i>
</div>
<div class="filter-cont" [hidden]="!filterIsToggled">
	<div class="card">
		
		<div class="card-title">
			<h2>Filter</h2>
		</div>
		<div class="cont">
			<div class="group">
				<div class="collapse-title" (click)="ele.class = ele.class == 'showChildren' ? '' :  'showChildren'">
					<h2>Type & Time Filter
						<i class="collapse-icon fa" [ngClass]=" ele.class !== 'showChildren' ? 'fa-minus' : 'fa-plus'"></i>
					</h2>
				</div> <!-- /.collapse-title -->

				<div class="collapse in show" id="filterCheckboxes" [ngClass]="{ hideChildren : ele.class == 'showChildren', showChildren : ele.class == 'hideChildren' }" #ele>
					<div class="group-cont">
						<div class="form-group sss-type-cbx hidden" [hidden]="!displayProductKindCheckBoxes">
							<div class="inputs filter checkbox">
								<h2>S&SS Type</h2>
								<ul class="checkbox-group checkbox-group-sum" id="sss_cbx">
									<li>
										<div class="checkbox">
											<label>
												<!--<input type="checkbox" id="stgCheckbox" class="STG">-->
												<input type="checkbox" name="sssType" [checked]="stgType" value="STG" id="stgType" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												
											
												STG
											</label>
										</div>
									</li>
									<li>
										<div class="checkbox">
											<label>
												<!--<input type="checkbox" id="swgCheckbox" class="SWG">-->
												<input type="checkbox" name="sssType" [checked]="swgType" value="SWG" id="swgType" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												
											
												SWG
											</label>
										</div>
									</li>
								</ul>
							</div>
						</div>
					
						
						<div class="form-group">
							<div class="inputs filter checkbox">
								<h2 for="">Year</h2>
								<ul class="checkbox-group year" id="yearul">
									<li *ngFor="let option of checkboxYear; let i = index">
										<div class="checkbox">
										<label>
											{{option.key}}
											<input type="checkbox" id="year-{{option.key}}" value="{{option.key}}" [checked]="option.value" (change)="onCheckBoxClicked($event)">  
											<span class="cr"><i class="cr-icon fas fa-check year" onclick="" id="year"></i></span>

											
										</label>   
										</div>
									</li>
								</ul>
							</div>
						</div>

						<div class="form-group">
							<div class="inputs filter checkbox">
								<h2 for="">Quarter</h2>
								<ul class="checkbox-group quarter" id="quarter">
									<li id="Q1">

										<div class="checkbox">
											<label>
												<input type="checkbox" name="quarter" [checked]="quarter1" value="1" id="quarter" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												Q1
											</label>
										</div>

									</li>
									<li id="Q2">

										<div class="checkbox">
											<label>

												<input type="checkbox" name="quarter" [checked]="quarter2" value="2" id="quarter" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
											Q2
											</label>
										</div>

									</li>
									<li id="Q3">

										<div class="checkbox">
											<label>

												<input type="checkbox" name="quarter" [checked]="quarter3" value="3" id="quarter" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												Q3
											</label>
										</div>

									</li>
									<li id="Q4">

										<div class="checkbox">
											<label>

												<input type="checkbox" name="quarter" [checked]="quarter4" value="4" id="quarter" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												Q4
											</label>
										</div>

									</li>
								</ul>
							</div>
						</div>

						<div class="form-group" *ngIf="filterForPage == 'opportunities'">
							<div class="inputs filter checkbox">
								<h2 for="">Month</h2>
								<ul class="checkbox-group month" id="month">
									<li id="M1">

										<div class="checkbox">
											<label>
												<input type="checkbox" name="month"  [checked]="month1" value="1" id="month" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												M1
											</label>
										</div> 
									</li>

									<li id="M1">
										<div class="checkbox">
											<label>
												<input type="checkbox" name="month" [checked]="month2" value="2" id="month" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												M2
											</label>
										</div>
									</li>

									<li id="M1">
										<div class="checkbox">
											<label>
												<input type="checkbox" name="month" [checked]="month3" value="3" id="month" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												M3
											</label>
										</div>
									</li>
								</ul>
							</div>
						</div>

						<div class="form-group">
							<div class="inputs filter checkbox">
								<h2 for=""></h2>
								<ul class="checkbox-group quarter">
									<li id="Q1">

										<div class="checkbox"  id="renewableul" >
											<label>
												<input type="checkbox" name="renewable"  [checked]="filters.renewable" value="true" id="renewable" class="cr" (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												Renewals
											</label>
										</div>

									</li>
									<li id="Qp1">

										<div class="checkbox"  id="partnerul" >
											<label>
												<input type="checkbox" name="partner" [checked]="filters.partner" value="true" id="partner" class="cr"  (click)="onCheckBoxClicked($event)">
												<span class="cr"><i class="cr-icon fas fa-check"></i></span>
												Partner
											</label>
										</div>

									</li>
								</ul>
							</div>
						</div>
					</div> <!-- /.group-cont -->
				</div> <!-- /.collapse in -->
			</div><!-- /.group -->
		</div><!-- /.cont -->

		<div class="cont">
			<div class="group">
				<div class="collapse-title" (click)="ele2.class = (ele2.class == 'showChildren' ? '' :  'showChildren');">
					<h2>Opportunity Specs Filter
						<i class="collapse-icon fa" [ngClass]=" ele2.class !== 'showChildren' ? 'fa-minus' : 'fa-plus'"></i>
					</h2>
				</div> <!-- /.collapse-title -->

				<div class="collapse in show" id="filterCheckboxes" [ngClass]="{ hideChildren : ele2.class == 'showChildren', showChildren : ele2.class == 'hideChildren' }" #ele2>
					<div class="group-cont">
						<!--<div class="form-group">
							<div class="inputs filter list" id="sbmc">
								<h2 class="">SBM Channel</h2>
								<span id="selectedsbmChannel" hidden></span>
								<select name="sbmchannel" class="checkbox-group status" id="sbmchannel" (change)="onDropDownClicked($event, 'sbmchannel')">
									<option id="All" value="All">All</option>
									<option value="SBM-CSS" [selected]="sbmcss">SBM CSS</option>
									<option value="SBM-NSS" [selected]="sbmnss">SBM NSS</option>
								</select>
							</div>
						</div>-->

						<div class="form-group">
							<div class="inputs filter list" id="genericstatus">
								<h2 class="">Generic Status</h2>
								<span id="selectedgstatus" hidden></span>
								<select name="genericstatus" class="checkbox-group status" id="gstatus" (change)="onDropDownClicked($event, 'genericstatus')">
									<option id="All" value="All" [selected]="filters.gstatus=='All'">All</option>
									<option value="Active" [selected]="filters.gstatus=='Active'">Active</option>
									<option value="InActive" [selected]="filters.gstatus=='InActive'">In-Active</option>
								</select>
							</div>
						</div>
						
						<div class="form-group">
							<div class="inputs filter list" id="status">
								<h2 class="">Status</h2>
								<span id="selectedstatus" hidden></span>
								<select name="status" class="status" id="statusdd" [(ngModel)]="filters.status" (change)="onDropDownClicked($event, 'status')">
									<option id="defaultStatus" value="null">Select Status: </option>
									<option id="All" value="All">All</option>
									
									<option *ngFor="let status of statusList; let i = index" [value]="status?.statusId">
										{{status?.status}}
									</option>
								</select>
								<!-- <p-dropdown [options]="statusList" optionLabel="status" placeholder="Select a Status" [showClear]="true"
								(onChange)="onDropDownClicked($event)" >
								</p-dropdown> -->
							</div>
						</div>

						<div class="form-group" *ngIf="filterForPage == 'boards'">
							<div class="inputs filter list" id="region">
								<h2 class="">Region</h2>
								<span id="selectedregion" hidden></span>
								<select name="region" class="region" id="dd1" [(ngModel)]="filters.region" (change)="onDropDownClicked($event, 'region')">
									<option id="All" value="All">All</option>
									<option *ngFor="let region of regionsList; let i = index" [value]="region?.regionId">
										{{region?.region}}
									</option>
								</select>
							</div>
						</div>

						<div class="form-group">
							<div class="inputs filter list" id="sector">
								<h2 class="">Sector</h2>
								<span id="selectedsector" hidden></span>
								<select name="sector" class="sector" id="dd3" [(ngModel)]="filters.sector" (change)="onDropDownClicked($event, 'sector')">
									<option id="All" value="All">All</option>
									<option *ngFor="let sector of sectors; let i = index" [value]="sector?.sectorId">
										{{sector?.sector}} 
									</option>
								</select>

									<!-- <p-dropdown [options]="sectors" optionLabel="sector" placeholder="Select a Sector" [showClear]="true"
									(onChange)="onDropDownClicked($event)" >
									</p-dropdown> -->
									
							</div>
						</div>

						<div class="form-group" *ngIf="filterForPage == 'boards'">
							<div class="inputs filter list" id="sales">
								<h2 class="">Sales</h2>
								<span id="selectedsales" hidden></span>
								<select name="sales" class="sales" id="dd2" [(ngModel)]="filters.sales"  (change)="onDropDownClicked($event, 'sales')">
									<option id="All" value="All">All</option>
									<option *ngFor="let user of salesUsers; let i = index" [value]="user?.userId">
										{{user?.firstName}} {{user?.lastName}} 
									</option>
								</select>
							</div>
						</div>
						
						<div class="form-group" *ngIf="filterForPage == 'opportunities'">
							<div class="inputs filter list" id="customer">
								<h2 class="">Customers</h2>
								<!-- <p-dropdown [options]="customerNameList" filter="true" 
								(onChange)="onDropDownClickedObject($event, 'customers' , option)" placeholder="Select a Customer" [showClear]="true">
									<ng-template let-option pTemplate="item">
										<div style="background-color: red;" id="{{option.id}}">{{option.label}}</div>
									</ng-template> -->


									<p-dropdown [options]="customerNameList" filter="true" 
    									(onChange)="onDropDownClickedObject($event, 'customers',  $event.value)" 
    										placeholder="Select a Customer" [showClear]="true">
    										<ng-template let-option pTemplate="item">
      									  <div style="background-color: #f8fbfe38; padding: 5px;" id="{{option.id}}">{{option.label}}</div>
  									  </ng-template>
									</p-dropdown>

							</div>
						</div>
						
						<div class="form-group" *ngIf="filterForPage == 'opportunities'">
							<div class="inputs filter list" id="opportunity">
								<h2 class="">Opportunities</h2>
								<!-- <p-dropdown [options]="opportunityNameList" filter="true" 
								(onChange)="8onDropDownClickedObject($event, 'opportunities' , option )" placeholder="Select an opportunity" [showClear]="true">
								<ng-template let-option pTemplate="item">
									<div id="{{option.id}}">{{option.label}}</div>
								</ng-template> -->

								<p-dropdown [options]="opportunityNameList" filter="true" 
    						(onChange)="onDropDownClickedObject($event, 'opportunities',  $event.value)" 
   								 placeholder="Select an opportunity" [showClear]="true">
    							<ng-template let-option pTemplate="item" >
     							   <div style="background-color: #f8fbfe38; padding: 5px;" id="{{option.id}}">{{option.label}}</div>
   								 </ng-template>
								</p-dropdown>
					
							</div>
						</div>                  


						


					</div> <!-- /.group-cont -->
				</div> <!-- /.collapse in -->
			</div><!-- /.group -->
		</div><!-- /.cont -->
	</div><!-- /.filter-cont -->
</div><!-- /.card -->
